"use strict";
let fdCollectionEpoch = 0;
let fdLoadController;

function fdInitCollectionMedia() {
  if (window.theme?.mlcurrency && typeof currenciesChange === 'function') {
    currenciesChange(document.querySelectorAll('product-card span.money'));
  }
  if (typeof initializeVideos === 'function') initializeVideos();
  if (typeof initBgimages === 'function') initBgimages();
  if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
}
function fdParseCollection(text) {
  const template = document.createElement('template');
  template.innerHTML = text;
  return template.content;
}
async function fdFetchRawCollection(url, signal) {
  const timeout = AbortSignal.timeout(20000);
  const combined = signal ? AbortSignal.any([signal, timeout]) : timeout;
  const response = await fetch(url, { signal: combined, credentials: 'same-origin' });
  if (!response.ok) throw new Error(`Collection request failed (${response.status})`);
  return fdParseCollection(await response.text());
}
let fdPaginationObserver;
function fdCollectionURL(url) {
  const result = new URL(url, location.href);
  const current = new URL(location.href);
  ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
    if (current.searchParams.has(key) && !result.searchParams.has(key)) {
      result.searchParams.set(key, current.searchParams.get(key));
    }
  });
  return result;
}
async function fdFetchCollection(url, signal) {
  return fdFetchRawCollection(fdCollectionURL(url), signal);
}
function fdCopyGrid(target, source, append = false) {
  if (!target || !source) throw new Error('Collection products missing');
  if (append) {
    const ids = new Set(Array.from(target.children, (node) => node.dataset.fdProductId));
    const incoming = Array.from(source.children);
    if (incoming.some((node) => node.dataset.fdProductId && ids.has(node.dataset.fdProductId))) {
      throw new Error('Collection changed; reload before loading more');
    }
    target.append(...incoming);
  } else {
    target.className = source.className;
    target.replaceChildren(...source.childNodes);
  }
  Object.keys(target.dataset).filter((key) => key.startsWith('fd')).forEach((key) => delete target.dataset[key]);
  Object.assign(target.dataset, source.dataset);
  target.hidden = false;
}
function fdCollectionNotice(message, anchor) {
  let notice = document.getElementById('fd-collection-notice');
  if (!message) { notice?.remove(); return; }
  if (!notice) {
    notice = document.createElement('p');
    notice.id = 'fd-collection-notice';
    notice.setAttribute('role', 'status');
    (anchor || document.getElementById('collection-products'))?.after(notice);
  }
  notice.textContent = message;
}
function pagination() {
  fdPaginationObserver?.disconnect();
  document.querySelectorAll('#pagination .load-more').forEach((btn) => {
    if (!btn.dataset.fdBound) {
      btn.dataset.fdBound = 'true';
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        loadMoreproducts(btn.href, btn);
      });
    }
    if (btn.classList.contains('infinite') && 'IntersectionObserver' in window) {
      fdPaginationObserver = new IntersectionObserver((entries, observer) => {
        if (entries.some((entry) => entry.isIntersecting) && btn.isConnected &&
            !document.body.classList.contains('load-filters')) {
          observer.disconnect();
          loadMoreproducts(btn.href, btn);
        }
      }, { rootMargin: '0px 0px 300px 0px', threshold: 0 });
      fdPaginationObserver.observe(btn);
    } else if (btn.classList.contains('infinite')) {
      btn.classList.remove('infinite');
      btn.classList.add('btn');
      btn.querySelector('svg')?.setAttribute('hidden', '');
      const label = btn.querySelector('p');
      if (label) label.textContent = btn.dataset.fdRetryLabel;
    }
  });
}
async function loadMoreproducts(url, btn = document.querySelector('.load-more')) {
  if (!btn || !btn.isConnected || btn.dataset.fdLoading === 'true' || document.body.classList.contains('load-filters')) return;
  fdPaginationObserver?.disconnect();
  if (btn.classList.contains('infinite')) {
    btn.querySelector('svg')?.removeAttribute('hidden');
    const label = btn.querySelector('p');
    if (label) label.textContent = btn.dataset.fdLoadingLabel;
  }
  btn.dataset.fdLoading = 'true';
  btn.classList.add('loading');
  btn.setAttribute('aria-busy', 'true');
  fdCollectionNotice('');
  const epoch = fdCollectionEpoch;
  try {
    if (epoch !== fdCollectionEpoch || !btn.isConnected) return;
    fdLoadController?.abort();
    const controller = new AbortController();
    fdLoadController = controller;
    const products = document.getElementById('collection-products');
    const requestURL = new URL(url, location.href);
    if (products?.dataset.fdSection) requestURL.searchParams.set('section_id', products.dataset.fdSection);
    const html = await fdFetchCollection(requestURL, controller.signal);
    if (controller.signal.aborted || epoch !== fdCollectionEpoch) return;
    fdCopyGrid(products, html.querySelector('#collection-products'), true);
    const paging = document.getElementById('pagination');
    if (paging) paging.innerHTML = html.querySelector('#pagination')?.innerHTML || '';
    pagination();
    fdInitCollectionMedia();
  } catch (error) {
    if (error.name !== 'AbortError' && epoch === fdCollectionEpoch) {
      fdCollectionNotice('Не успяхме да заредим още продукти. Натиснете бутона отново.', btn);
      if (btn.classList.contains('infinite')) {
        btn.querySelector('svg')?.setAttribute('hidden', '');
        const label = btn.querySelector('p');
        if (label) label.textContent = btn.dataset.fdRetryLabel;
      }
      console.warn('Could not load more products.', error);
    }
  } finally {
    btn.classList.remove('loading');
    btn.removeAttribute('aria-busy');
    delete btn.dataset.fdLoading;
  }
}
pagination();

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var _this = this,
        fbtns = document.querySelectorAll(".btn-filter"),
        topFilters = document.querySelector(".filter-horizontal");

      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 767px)');
  
      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      this.selectSort();

      document.addEventListener('change', function(e){
        if (!e.target.classList.contains('optTag')) return;

        var URL = _this.dataset.url,
            paramString = new URLSearchParams(window.location.search),
            productFilters = document.querySelectorAll('input.optTag'),
            newTags = [],
            bytags = true;

        productFilters.forEach(function(el){
            if(el.value && el.checked){
                newTags.push(el.value);
            }
        });

        paramString.delete('page');
        if (newTags.length) {
            var tags = newTags.join('+');
            _this.renderSectionFromFetch(URL + '/' + tags + '?' + paramString, bytags);
        } else {
            _this.renderSectionFromFetch(URL + '?' + paramString, bytags);
        }
      });

  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    shortby?.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input.dyfl, .price-range');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  priceRangeSlider(){
    const isPriceRange = document.getElementById('priceSlider');
    if(!isPriceRange) return;
    const priceSlider = document.getElementById('priceSlider'),
      min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE');

    priceSlider.addEventListener('change', (evt) => {
        min.value = evt.detail.value1.toString();
        max.value = evt.detail.value2.toString();
    });
    priceSlider.addEventListener('onMouseUp', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
    priceSlider.addEventListener('touchend', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
  }
  onFormSubmit(e) {
    const form = this.querySelector('form');
    if (!form) return;
    const params = new URLSearchParams(new FormData(form));
    [...params.entries()].forEach(([key, value]) => { if (value === '') params.delete(key); });
    const current = new URL(location.href);
    ['type', 'view', 'preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.searchParams.has(key)) params.set(key, current.searchParams.get(key));
    });
    params.delete('page');
    this.renderSectionFromFetch(params);
  }
  async renderSectionFromFetch(params, tags) {
    const target = tags ? new URL(params, location.href) : new URL(location.pathname, location.origin);
    if (!tags) target.search = params.toString();
    const current = new URL(location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.searchParams.has(key) && !target.searchParams.has(key)) {
        target.searchParams.set(key, current.searchParams.get(key));
      }
    });
    target.searchParams.delete('section_id');
    target.searchParams.delete('page');
    const requestURL = new URL(target);
    requestURL.searchParams.set('section_id', this.secId);
    fdCollectionEpoch += 1;
    fdPaginationObserver?.disconnect();
    const epoch = fdCollectionEpoch;
    fdLoadController?.abort();
    this.fdController?.abort();
    const controller = new AbortController();
    this.fdController = controller;
    document.body.classList.add('load-filters');
    fdCollectionNotice('');
    try {
      const html = await fdFetchCollection(requestURL, controller.signal);
      if (controller.signal.aborted || epoch !== fdCollectionEpoch) return;
      fdCopyGrid(document.getElementById('collection-products'), html.querySelector('#collection-products'));
      const brandScroll = document.querySelector('#fd-brand-carousel [data-brand-viewport]')?.scrollLeft;
      const focusedBrand = document.activeElement?.closest('[data-fd-brand-link]')?.dataset.fdBrandLink;
      ['itemsCount', 'fd-collection-count', 'active-filters', 'pagination', 'fd-brand-carousel', 'fd-delivery-buttons'].forEach((id) => {
        const destination = document.getElementById(id);
        const source = html.querySelector(`#${id}`);
        if (destination) {
          destination.innerHTML = source?.innerHTML || '';
          if (source?.hasAttribute('aria-label')) destination.setAttribute('aria-label', source.getAttribute('aria-label'));
        }
      });
      document.querySelector('fd-brand-carousel')?.restorePosition?.(brandScroll, focusedBrand);
      const filters = this.querySelector('.filters-item__wrapper');
      const sourceFilters = html.querySelector('.filters-item__wrapper');
      const filterFocus = this.contains(document.activeElement) ? document.activeElement?.getAttribute('data-filter-open') : null;
      if (filters && sourceFilters) filters.innerHTML = sourceFilters.innerHTML;
      if (filterFocus) [...this.querySelectorAll('[data-filter-open]')].find((button) => button.dataset.filterOpen === filterFocus)?.focus({ preventScroll: true });
      const sort = document.getElementById('sort-by');
      const sourceSort = html.querySelector('#sort-by');
      if (sort && sourceSort) sort.value = sourceSort.value;
      history.pushState({ page: target.href }, '', target);
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      pagination();
      fdInitCollectionMedia();
    } catch (error) {
      if (error.name !== 'AbortError' && epoch === fdCollectionEpoch) {
        fdCollectionNotice('Филтрите не се обновиха. Опитайте отново или презаредете страницата.');
        console.warn('Could not update the collection.', error);
      }
    } finally {
      if (epoch === fdCollectionEpoch) {
        document.body.classList.remove('load-filters');
        pagination();
      }
    }
  }
  removeFilters() {
    document.querySelectorAll('.active-fl').forEach((btn) => {
      if (btn.dataset.fdBound) return;
      btn.dataset.fdBound = 'true';
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.renderSectionFromFetch(btn.href, true);
      });
    });
  }
  mobileFilters(){
    var html = document.documentElement;
    html.classList.add('activ-filter','show-overly');
    const blocks = this.querySelectorAll('.filters-item');
    blocks.forEach((blk) => {
      blk.open = true;
    });
    document.querySelector(".closeFilter").addEventListener('click', function(e){
        html.classList.remove('activ-filter','show-overly');
    });
  }
  blockToggle(){
      const body = document.body,
        filters = document.querySelectorAll(".filter-horizontal .filters-title"),
        blocks = this.querySelectorAll('.filters-item');
      filters.forEach((blk) => {
        const act = blk.closest('.filters-item[open]');
        blocks.forEach((other) => {
           if(other !== act){
             other.removeAttribute('open');
           }
        });
      });
      body.addEventListener('click', function(e){
          blocks.forEach((blk) => {
            if(e.target.closest('.filters-item[open]')) return;
             blk.removeAttribute('open');
        });
      });
  }
}
if (!customElements.get('filters-form')) customElements.define('filters-form', FiltersForm);
window.addEventListener('popstate', () => location.reload());
if (!document.querySelector('filters-form')) {
  document.getElementById('sort-by')?.addEventListener('change', (event) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    location.assign(url);
  });
}

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});




